import { Ellypsis } from '@atom-learning/icons'
import React from 'react'

import { ActionIcon } from '../action-icon/ActionIcon'
import { Icon } from '../icon/Icon'
import { Popover } from '../popover/Popover'
import { PaginationPage } from './PaginationPage'
import { usePagination } from './usePagination'

export const PaginationPopover = ({
  children
}: React.PropsWithChildren<unknown>) => {
  const { pagesCount, labels } = usePagination()
  const paginationItems = Array.from(
    { length: pagesCount },
    (_, index) => index + 1
  )

  const [isOpen, setIsOpen] = React.useState<boolean>(false)

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen} defaultOpen={false}>
      <Popover.Trigger asChild>
        {children || (
          <ActionIcon
            hasTooltip={false}
            size="md"
            theme="neutral"
            label={labels?.popoverTriggerLabel || 'Open pagination popover'}
            data-testid="pagination_popover_trigger"
          >
            <Icon is={Ellypsis} />
          </ActionIcon>
        )}
      </Popover.Trigger>
      <Popover.Content size="md" showCloseButton={false} className="p-0">
        <div className="flex flex-wrap justify-center gap-1 p-4">
          {paginationItems?.map((pageNumber) => {
            return (
              <PaginationPage
                key={pageNumber}
                pageNumber={pageNumber}
                onClick={() => setIsOpen(false)}
              />
            )
          })}
        </div>
      </Popover.Content>
    </Popover>
  )
}
